import _ from 'underscore';

export const CampaignSubTypes = {
  AudienceStatic: 'AudienceStatic',
  AudienceFeedBased: 'AudienceFeedBased',
  AudienceDynamicFeedBased: 'AudienceDynamicFeedBased',
  AudienceVideoAds: 'AudienceVideoAds',
  BrandAwarenessVideoAds: 'BrandAwarenessVideoAds',
  DisplayAds: 'DisplayAds',
  ShoppingCoOperative: 'ShoppingCoOperative',
  ShoppingSponsoredProductAd: 'ShoppingSponsoredProductAd',
  ShoppingSmartAds: 'ShoppingSmartAds',
};

export const CampaignSubTypeMapping = {
  [CampaignSubTypes.AudienceStatic]: 0,
  [CampaignSubTypes.AudienceFeedBased]: 1,
  [CampaignSubTypes.AudienceDynamicFeedBased]: 2,
  [CampaignSubTypes.AudienceVideoAds]: 3,
  [CampaignSubTypes.BrandAwarenessVideoAds]: 4,
  [CampaignSubTypes.DisplayAds]: 5,
  [CampaignSubTypes.ShoppingCoOperative]: 10,
  [CampaignSubTypes.ShoppingSponsoredProductAd]: 11,
  [CampaignSubTypes.ShoppingSmartAds]: 12,
};

export const FeedBasedCampaginSubTypes = [
  CampaignSubTypeMapping.AudienceFeedBased,
  CampaignSubTypeMapping.AudienceDynamicFeedBased,
];

export const AudienceCampaignSubTypes = [
  CampaignSubTypeMapping.AudienceStatic,
  CampaignSubTypeMapping.AudienceVideoAds,
  CampaignSubTypeMapping.DisplayAds,
];

export const CampaignSubTypeAPIMapping = {
  VideoAds: CampaignSubTypeMapping.AudienceVideoAds,
  StaticAds: CampaignSubTypeMapping.AudienceStatic,
};

export const isFeedBasedAudienceCampaign = campaignSubType =>
  // AudienceFeedBased = 1,
  // AudienceDynamicFeedBased = 2,
  campaignSubType === 1 || campaignSubType === 2 || campaignSubType === 'AudienceFeedBased' || campaignSubType === 'AudienceDynamicFeedBased';

export const CampaignSubTypeTextMapping = _.invert(CampaignSubTypeMapping);

export const CampaignSubTypeValueToAPIMapping = _.invert(CampaignSubTypeAPIMapping);
